"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Constants_1 = require("./Constants");
function getAuthenticationHeader(accessToken) {
    return 'Bearer ' + accessToken;
}
var AxiosHttpInterceptorBuilder = (function () {
    function AxiosHttpInterceptorBuilder(logService, tokenService, axiosInstance) {
        this.logService = logService;
        this.tokenService = tokenService;
        this.axiosInstance = axiosInstance;
    }
    AxiosHttpInterceptorBuilder.prototype.build = function () {
        var tokenService = this.tokenService;
        var axios = this.axiosInstance;
        var logService = this.logService;
        var refreshTokenCallFailed = false, refreshTokenPromise = null;
        function applyAccessToken(config) {
            var accessToken;
            config.headers = config.headers || {};
            accessToken = tokenService.getAccessToken();
            if (accessToken) {
                config.headers.Authentication = getAuthenticationHeader(accessToken);
            }
            // This is for anonymous sharing.
            // API expects all anonymous calls don't have authentication attribute in header
            if (config.isAnonymousCall) {
                delete config.isAnonymousCall;
                delete config.headers.Authentication;
            }
            return config;
        }
        function onBeforeRequest(config) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(refreshTokenPromise && !refreshTokenCallFailed &&
                                !Constants_1.default.TokenRefreshUrlRegExp.test(config.url))) return [3 /*break*/, 2];
                            return [4 /*yield*/, refreshTokenPromise];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/, applyAccessToken(config)];
                    }
                });
            });
        }
        function onRequestError(error) {
            // Do something with request error
            return Promise.reject(error);
        }
        // Add a response interceptor
        function onResponseSuccess(response) {
            // Do something with response data
            return response;
        }
        function resetRefreshTokenPromise() {
            refreshTokenPromise = null;
        }
        function onResponseError(error) {
            var config = error.config;
            if (!config ||
                !config.url ||
                error.response.status !== Constants_1.default.HttpStatuses.UNAUTHORIZED ||
                refreshTokenCallFailed) {
                return Promise.reject(error);
            }
            if (Constants_1.default.TokenRefreshUrlRegExp.test(config.url)) {
                refreshTokenCallFailed = true;
                return Promise.reject(error);
            }
            //When any API fails, check if the access token has changed between the initial request and at the time of response failure
            if (!config.headers.Authentication ||
                getAuthenticationHeader(tokenService.getAccessToken()) === config.headers.Authentication) {
                if (!refreshTokenPromise) {
                    logService.info("Encountered access token failure scenario, refreshing access token behind the scenes.");
                    refreshTokenPromise = tokenService.refreshAccessToken();
                    refreshTokenPromise.then(resetRefreshTokenPromise, resetRefreshTokenPromise);
                }
                else {
                    logService.info("Encountered access token failure scenario, waiting on pending refresh token promise to retry method");
                }
                return new Promise(function (resolve, reject) {
                    refreshTokenPromise.then(function () {
                        axios(error.config).then(resolve, reject);
                    }, function () {
                        reject(error);
                    });
                });
            }
            else {
                return axios(error.config);
            }
        }
        ;
        return {
            onBeforeRequest: onBeforeRequest,
            onRequestError: onRequestError,
            onResponseSuccess: onResponseSuccess,
            onResponseError: onResponseError
        };
    };
    return AxiosHttpInterceptorBuilder;
}());
exports.default = AxiosHttpInterceptorBuilder;
